<template>
    <v-sheet>
        <v-data-table v-model="selected" v-bind="{ items, headers }" show-select single-select item-key="tempId" checkbox-color="primary" hide-default-footer disable-filtering disable-sort :items-per-page="-1">
            <template #top> <v-divider class="border-2 primary" /> </template>

            <template #[`item.type`]="{ item }">
                <v-select v-model="item.type" :items="types" :disabled="!!item._id" :menuProps="{ attach: `.form-questions-item-type-${className}-${item.tempId.toString().slice(2)}` }" :class="`form-questions-item-type-${className}-${item.tempId.toString().slice(2)}`" outlined attach @input="emit" />
                <v-checkbox v-if="item.type == RECRUITMENT_QUESTION_TYPES.MULTIPLE_CHOICE.value" v-model="item.isMultipleSelect" label="복수선택" outlined color="primary" @input="emit" />
            </template>

            <template #[`item.subject`]="{ item }">
                <v-text-field v-model="item.subject" outlined class="subject-field my-12" @input="emit">
                    <template #prepend-inner>질문 : </template>
                </v-text-field>
                <template v-if="item.type == RECRUITMENT_QUESTION_TYPES.MULTIPLE_CHOICE.value">
                    <v-combobox v-model="item.choices" outlined multiple append-icon="" placeholder="항목을 적고 Enter를 눌러 추가하세요" class="choices-field my-12" @input="emit">
                        <template #prepend-inner>선택지 : </template>
                        <template #selection="{ item, parent }">
                            <draggable v-model="item.choices">
                                <v-chip small close color="grey-ec" class="mb-6 mb-10" @click:close="parent.selectItem(item)">{{ item }}</v-chip>
                            </draggable>
                        </template>
                    </v-combobox>
                </template>
            </template>

            <template #[`item.actions`]="{ item }">
                <v-btn icon x-small class="u-pink ma-auto" @click="remove(item)"><i class="icon icon-minus" /></v-btn>
            </template>

            <template #foot>
                <tfoot>
                    <td :colspan="headers.length + 1">
                        <v-divider />
                        <v-layout class="mt-10">
                            <v-btn :disabled="upDisabled" icon text x-small @click="upItem"><v-icon class="font-size-28 mr-4"> mdi-chevron-up </v-icon></v-btn>
                            <v-btn :disabled="downDisabled" icon text x-small @click="downItem"><v-icon class="font-size-28"> mdi-chevron-down </v-icon></v-btn>
                        </v-layout>
                        <v-btn block color="grey-f8" class="v-btn--plus rounded-lg" @click="addAnItem"> <i class="icon icon-plus-sm" /> </v-btn>
                    </td>
                </tfoot>
            </template>
        </v-data-table>
    </v-sheet>
</template>

<script>
import { RECRUITMENT_QUESTION_TYPES } from "@/assets/variables";

import Draggable from "vuedraggable";

const types = Object.values(RECRUITMENT_QUESTION_TYPES);

const headers = [
    { width: 180, text: "유형", value: "type", align: "center" },
    { width: 860, text: "내용", value: "subject", align: "center" },
    { width: +80, text: "", value: "actions", align: "center" },
];

const initQuestion = () => ({
    tempId: Math.random(),
    type: RECRUITMENT_QUESTION_TYPES.SHORT_ANSWER.value,
    subject: null,
});

export default {
    components: {
        Draggable,
    },
    props: {
        value: { type: Array, default: () => [] },
    },
    data: () => ({
        items: [],

        selected: [],

        types,
        headers,

        RECRUITMENT_QUESTION_TYPES,
        className: Math.random().toString().slice(2),
    }),
    computed: {
        selectedIndex() {
            return this.items.findIndex(({ tempId }) => tempId == this.selected[0]?.tempId);
        },
        upDisabled() {
            return this.selectedIndex < 1;
        },
        downDisabled() {
            return !(-1 < this.selectedIndex && this.selectedIndex < this.items.length - 1);
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.items = [...this.value];
        },
        emit() {
            this.$emit("input", [...this.items]);
        },
        addAnItem() {
            this.items.push(initQuestion());
        },
        remove(item) {
            this.items = this.items.filter(({ tempId }) => tempId != item.tempId);
            this.emit();
        },
        upItem() {
            let index = this.selectedIndex;
            this.items.splice(index - 1, 2, this.items[index], this.items[index - 1]);
            this.emit();
        },
        downItem() {
            let index = this.selectedIndex;
            this.items.splice(index, 2, this.items[index + 1], this.items[index]);
            this.emit();
        },
    },
};
</script>
<style lang="scss" scoped>
::v-deep {
    thead th:first-of-type:not(:last-of-type),
    tbody td:first-of-type:not(:last-of-type) {
        width: 58px !important;
    }

    // td {
    //     vertical-align: top;
    // }
    .v-data-table__empty-wrapper td {
        vertical-align: middle;
    }

    .v-data-table__checkbox {
        display: flex;
        margin: 12px 0;
        height: 50px;
        align-items: center;
        justify-content: center;

        .v-input--selection-controls__input {
            margin: 0;
        }
    }

    .type-field {
        align-self: flex-start;
    }

    .subject-field,
    .choices-field {
        .v-input__slot {
            height: auto;
            align-items: baseline;
            > .v-input__prepend-inner {
                flex: 0 0 60px;
                align-self: inherit;

                line-height: 50px;
            }
        }
    }
}
</style>